import React from 'react'
import { useTranslation } from 'react-i18next'
import { Container, PageTitle } from '~/shared/ui/Layout'
import { PageContainer } from '~/shared/ui/Layout'
import RoutesTabs from '~/shared/ui/RoutesTabs'
import { useConfigTabs } from './useConfigTabs'

function SettingsPage() {
  const configTabs = useConfigTabs()
  const { t } = useTranslation()

  return (
    <PageContainer title={t('settings')}>
      <RoutesTabs
        parentPath='/settings'
        config={configTabs}
        parentContent={
          <Container isHeader>
            <PageTitle>{t('settings')}</PageTitle>
          </Container>
        }
      />
    </PageContainer>
  )
}

export default SettingsPage
